import webmdads from 'webmd-ads-consumer';
export default {
  install: function(app, options) {
    if (typeof window !== 'undefined') {
      app.dfpLoaded = new Promise(function(resolve, reject) {
        resolve("Finished Loading GPT Library");
      });

      app.adsPromiseQueue = [];
      app.mixin({
        created:function () {
          // dependency injection to make the global Vue instance available in component
          this.$vue = app;
        }
      });
    }
  }
};